'use strict';
var IndexedObject = require('../internals/indexed-object');
var requireObjectCoercible = require('../internals/require-object-coercible');

/**
 * 获取索引对象
 * @param {any} it 数据
 * @returns {any[]}
 */
module.exports = function(it) {
  return IndexedObject(requireObjectCoercible(it));
};
